import React from 'react'
import { fallDown as MenuBurgerComponent } from 'react-burger-menu'
import styles from '../../styles'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import logout from '../../api/logout'
import { makeStyles } from '@material-ui/core/styles'
import links from '../../enums/linksEnum'
import { useCookies } from 'react-cookie'
import portals from '../../enums/portalsEnum'
import { useSelector } from 'react-redux'
import { RootState } from '../../modules/reducers'
import { redirectionVersAcquisitionResidence } from '../../modules/changementAppartement/utils/changementAppartementUtils'

const useStyle = makeStyles(
	(theme) => styles(theme)
)

interface AcceptingProps {
	onClick: (lien: string) => void,
	open: boolean,
	linkIsSelected: (linksArray: string[], link: string) => string
}

type MenuBurgerProps =
	AcceptingProps

const MenuBurger: React.FC<MenuBurgerProps> = (
	{
		onClick,
		open,
		linkIsSelected
	}
) => {
	const classes = useStyle()
	const history = useHistory()
	const removeCookies = useCookies()[2]
	const intl = useIntl()
	const dossier = useSelector((state: RootState) => state.dossier)

	const link = history.location.pathname
	const linksDashboard: string[] = [links.dashboard]
	const linksNews: string[] = [links.news]
	const linksServices: string[] = [links.services]
	const linksContracts: string[] = [links.contracts]
	const linksRequests: string[] = [links.requests]
	const linksQuestions: string[] = [links.questions]
	const linksProfile: string[] = [links.profile]

	const linkClass: ClassValue = classNames(
		'menu-item',
		classes.title5,
		classes.cursorPointer
	)

	return (
		<>
			<MenuBurgerComponent
				outerContainerId="outer-container"
				right
				width={'100%'}
				customBurgerIcon={false}
				customCrossIcon={false}
				isOpen={open}
				noOverlay
			>
				<span
					id="dashboard"
					className={linkClass}
					onClick={() => onClick(links.dashboard)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksDashboard, link)}
					>
						<FormattedMessage
							id="menu.dashboard"
							defaultMessage="Tableau de bord"
							description="Dashboard text"
						/>
					</span>
				</span>

				<span
					id="news"
					className={linkClass}
					onClick={() => onClick(links.news)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksNews, link)}
					>
						<FormattedMessage
							id="menu.news"
							defaultMessage="Actualités"
							description="News text"
						/>
					</span>
				</span>

				{
					process.env.REACT_APP_TARGET === portals.campus &&
						<span
							id="services"
							className={linkClass}
							onClick={() => onClick(links.services)}
						>
							<ChevronRightIcon />

							<span
								className={linkIsSelected(linksServices, link)}
							>
								<FormattedMessage
									id="menu.services"
									defaultMessage="Services"
									description="Services text"
								/>
							</span>
						</span>
				}

				<span
					id="contracts"
					className={linkClass}
					onClick={() => onClick(links.contracts)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksContracts, link)}
					>
						<FormattedMessage
							id="menu.contracts"
							defaultMessage="Votre compte"
							description="your account text"
						/>
					</span>
				</span>

				<span
					id="requests"
					className={linkClass}
					onClick={() => onClick(links.requests)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksRequests, link)}
					>
						<FormattedMessage
							id="menu.requests"
							defaultMessage="Vos demandes"
							description="Requests text"
						/>
					</span>
				</span>

				<span
					id="questions"
					className={linkClass}
					onClick={() => onClick(links.questions)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksQuestions, link)}
					>
						<FormattedMessage
							id="menu.questions"
							defaultMessage="Questions ?"
							description="Questions text"
						/>
					</span>
				</span>

				<span
					id="profile"
					className={linkClass}
					onClick={() => onClick(links.profile)}
				>
					<ChevronRightIcon />

					<span
						className={linkIsSelected(linksProfile, link)}
					>
						<FormattedMessage
							id="menu.profile"
							defaultMessage="Votre profil"
							description="Profile text"
						/>
					</span>
				</span>

				{process.env.REACT_APP_TARGET === portals.residence && dossier && (
					<span
						id="dossier"
						className={linkClass}
						onClick={() => redirectionVersAcquisitionResidence(intl.locale)}
					>
						<ChevronRightIcon />

						<span>
							<FormattedMessage
								id="menu.dossier"
								defaultMessage="Votre dossier"
								description="Lien vers le suivi de dossier sur l'acquisition résidence"
							/>
						</span>
					</span>
				)}

				<span
					id="logout"
					className={linkClass}
					onClick={() => logout(removeCookies)}
				>
					<ChevronRightIcon />

					<span>
						<FormattedMessage
							id="menu.logout"
							defaultMessage="Se déconnecter"
							description="Logout text"
						/>
					</span>
				</span>
			</MenuBurgerComponent>
		</>
	)
}

export default MenuBurger